import { Clock, Send, CheckCircle, FileSearch, ShieldCheck, XCircle, Edit3 } from 'lucide-react'
import { StatoOfferta } from '../../types/offerte'

interface StatusBadgeProps {
  stato: StatoOfferta
  size?: 'sm' | 'md'
}

const statusConfig: Record<string, { label: string; icon: typeof Clock; className: string }> = {
  bozza: {
    label: 'Bozza',
    icon: Edit3,
    className: 'bg-gray-100 text-gray-700 border-gray-200',
  },
  in_corso: {
    label: 'Bozza',
    icon: Edit3,
    className: 'bg-gray-100 text-gray-700 border-gray-200',
  },
  in_revisione: {
    label: 'In Revisione',
    icon: FileSearch,
    className: 'bg-purple-100 text-purple-700 border-purple-200',
  },
  approvata: {
    label: 'Approvata',
    icon: ShieldCheck,
    className: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  },
  in_attesa: {
    label: 'In Attesa',
    icon: Send,
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  confermata: {
    label: 'Confermata',
    icon: CheckCircle,
    className: 'bg-green-100 text-green-700 border-green-200',
  },
  rifiutata: {
    label: 'Rifiutata',
    icon: XCircle,
    className: 'bg-red-100 text-red-700 border-red-200',
  },
}

export function StatusBadge({ stato, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[stato] || statusConfig.bozza
  if (!config) return null
  const Icon = config.icon

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-3 py-1 text-sm'

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${config.className} ${sizeClasses}`}>
      <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} />
      {config.label}
    </span>
  )
}
